import React from 'react';

/** @internal */
export var verticalLineIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "1",
  height: "22",
  viewBox: "0 0 1 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("line", {
  x1: "0.5",
  x2: "0.5",
  y2: "22",
  className: "sicl-icon-stroke-color"
}));